import { useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * usePrefillBirthDetails — one-shot prefill of a tool's birth-detail form
 * from the signed-in user's saved profile.
 *
 * Usage:
 *   usePrefillBirthDetails(setForm, setPlaceQuery);
 *
 * setForm: (formMerge) => void — your tool's setState that merges {date,time,place,timezone}
 * setPlaceQuery: (place) => void — your tool's placeQuery setter (optional)
 *
 * Fires once when user.birth_details is first available; never overwrites
 * after the user starts editing.
 */
export default function usePrefillBirthDetails(setForm, setPlaceQuery) {
  const { user } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    const bd = user?.birth_details;
    if (!bd?.date || !bd?.time || !bd?.place) return;
    done.current = true;
    setForm?.((prev) => ({
      ...prev,
      date: bd.date,
      time: bd.time,
      place: bd.place,
      timezone: bd.timezone || prev?.timezone || "Asia/Kolkata",
    }));
    setPlaceQuery?.(bd.place);
  }, [user, setForm, setPlaceQuery]);
}
